'use strict';var $=require('../internals/export');var call=require('../internals/function-call');// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$({target:'URL',proto:true,enumerable:true},{toJSON:function toJSON(){return call(URL.prototype.toString,this);}});